__turbopack_context__.v({
  "actionContainer": "pEzzyq_actionContainer",
  "actionIcon": "pEzzyq_actionIcon",
  "actionText": "pEzzyq_actionText",
  "arrow": "pEzzyq_arrow",
  "bottomLine": "pEzzyq_bottomLine",
  "container": "pEzzyq_container",
  "image": "pEzzyq_image",
  "imageWrapper": "pEzzyq_imageWrapper",
  "link": "pEzzyq_link",
});
